<template>
  <div class="table">
    <div class="container" style="float: right; width: 95%">
      <div style="height: 40px; margin: 5px 16px 0 0px">
        <div style="display: inline-block; height: 40px">
          <div style="width: 160px">
            <el-select v-model="form.deptId" placeholder="请选择学校" @change="getModuleBindIndicators">
              <el-option v-for="item in depts" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </div>
        </div>
        <div style="display: inline-block; height: 40px">
          <div style="width: 160px">
            <el-input v-model="form.serialNo" placeholder="编号"></el-input>
          </div>
        </div>
        <div style="display: inline-block; height: 40px">
          <div style="width: 160px">
            <el-select v-model="form.moduleId" placeholder="评价模块" clearable>
              <el-option v-for="item in evaluateModules" :key="item.moduleId" :label="item.moduleTitle"
                :value="item.moduleId">
              </el-option>
            </el-select>
          </div>
        </div>
        <div style="display: inline-block; height: 40px">
          <div style="width: 160px">
            <el-select v-model="form.checkStatus" clearable placeholder="审核状态">
              <el-option v-for="item in checkStatuss" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div style="display: inline-block; height: 40px">
          <div style="width: 160px">
            <el-input v-model="form.name" placeholder="学生姓名"></el-input>
          </div>
        </div>
        <div style="display: inline-block; height: 40px">
          <div style="width: 160px">
            <el-input v-model="form.gradeName" placeholder="年级名称"></el-input>
          </div>
        </div>
        <div style="display: inline-block; height: 40px">
          <div style="width: 160px">
            <el-input v-model="form.className" placeholder="班级名称"></el-input>
          </div>
        </div>
        <div style="display: inline-block; height: 40px">
          <div style="width: 160px">
            <el-input v-model="form.evaluateTitle" placeholder="评价指标"></el-input>
          </div>
        </div>
        <div style="display: inline-block; height: 40px">
          <div style="width: 160px">
            <el-input v-model="form.createName" placeholder="评价人"></el-input>
          </div>
        </div>
        &nbsp;
        <el-button type="primary" icon="search" @click="common.page = 1; getData();">查询</el-button>
      </div>
      <div style="height: 40px; margin: 5px 16px 0 0px">
        <div style="display: inline-block; height: 40px; margin-right: 5px; float: right; ">
          <el-button type="warning" @click="batchDelete()">批量删除</el-button>
        </div>
        <div style="display: inline-block; height: 40px; margin-right: 5px; float: right; ">
          <el-button type="warning" @click="batchCancel()">批量撤销</el-button>
        </div>
        <div style="display: inline-block; height: 40px;  margin-right: 5px;  float: right">
          <el-button type="primary" @click="batchCheck()">一键审批</el-button>
        </div>
      </div>

      <el-table :data="data" style="width: 100%; margin-bottom: 20px" row-key="id" border v-loading="loading"
        :element-loading-text="loadingText" element-loading-background="rgba(255, 255,255,0.7)" default-expand-all
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="40" :selectable="selectable"></el-table-column>
        <el-table-column type="index" label="序号" width="55" :index="indexMethod">
        </el-table-column>
        <el-table-column prop="" label="编号" :show-overflow-tooltip="true" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.serialNo != null && scope.row.serialNo != ''">
              {{ scope.row.serialNo }}
            </div>
            <div v-else>无</div>
          </template>
        </el-table-column>
        <el-table-column prop="evaluateModule" label="评价模块" width="130">
          <template slot-scope="scope">
            <div v-if="scope.row.evaluateModule == 1">学生评价</div>
            <div v-else-if="scope.row.evaluateModule == 2">课堂评价</div>
            <div v-else-if="scope.row.evaluateModule == 3">
              班级评价/
              <span v-if="scope.row.commonName != null">
                {{ scope.row.commonName }}/
              </span>
              {{ scope.row.classEvaluateIndicatorsName }}
            </div>
            <div v-else-if="scope.row.evaluateModule == 4">实践评价</div>
            <div v-else-if="scope.row.evaluateModule == 6">成果作业</div>
            <div v-else>无</div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="学生姓名" :show-overflow-tooltip="true" width="100"></el-table-column>
        <el-table-column prop="gradeName" label="年级名称" :show-overflow-tooltip="true" width="100"></el-table-column>
        <el-table-column prop="className" label="班级名称" :show-overflow-tooltip="true" width="100"></el-table-column>
        <el-table-column prop="evaluateTitle" label="评价指标" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="evaluateType" label="评价类型" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div v-if="scope.row.evaluateType == 1">表扬</div>
            <div v-else-if="scope.row.evaluateType == 2">待改进</div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="评价分值" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div v-if="scope.row.evaluateType == 1">
              +{{ scope.row.evaluateScore }}
            </div>
            <div v-else-if="scope.row.evaluateType == 2">
              <span style="color: red">{{ scope.row.evaluateScore }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="evaluateContent" label="评价内容" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="evaluateTime" label="评价时间" width="100"></el-table-column>
        <el-table-column prop="" label="评价人" width="80">
          <template slot-scope="scope">
            <div v-if="userId == '1' || scope.row.checkUsers.indexOf(userId) > -1">
              {{ scope.row.createName }}
            </div>
            <div v-else>匿名</div>
          </template>
        </el-table-column>
        <el-table-column prop="checkStatus" label="审核状态" width="80px">
          <template slot-scope="scope">
            <div v-if="scope.row.checkStatus == 0">
              <span style="color: red">不通过</span>
            </div>
            <div v-else-if="scope.row.checkStatus == 1">待审核</div>
            <div v-else-if="scope.row.checkStatus == 2">
              <span style="color: green">通过</span>
            </div>
            <div v-else-if="scope.row.checkStatus == 4">
              <span style="color: red">正在删除</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="checkRemark" label="审核备注" :show-overflow-tooltip="true" width="100px">
        </el-table-column>
        <el-table-column prop="commonName" label="审核人" :show-overflow-tooltip="true" width="100px">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="80px" style="text-align: 'left'">
          <template slot-scope="scope">
            <div v-if="userId == '1'">
              <el-button style="color: #387ee8" v-if="scope.row.checkStatus == 2"
                @click.native.prevent="cancelUser(scope.row.id)" type="text" size="small">
                撤销
              </el-button>
              <el-button style="color: #387ee8" v-if="scope.row.checkStatus == 1"
                @click.native.prevent="checkUser(scope.row.id)" type="text" size="small">
                审核
              </el-button>
              <el-button style="color: red" v-if="scope.row.checkStatus == 1" @click.native.prevent="del(scope.row)"
                type="text" size="small">
                删除
              </el-button>
            </div>
            <div v-else>
              <el-button style="color: #387ee8" v-if="
                scope.row.checkStatus == 2 &&
                scope.row.checkUsers.indexOf(userId) > -1
              " @click.native.prevent="cancelUser(scope.row.id)" type="text" size="small">
                撤销
              </el-button>
              <el-button style="color: #387ee8" v-if="
                scope.row.checkStatus == 1 &&
                scope.row.checkUsers.indexOf(userId) > -1
              " @click.native.prevent="checkUser(scope.row.id)" type="text" size="small">
                审核
              </el-button>
              <el-button style="color: red" v-if="
                scope.row.checkStatus == 1 &&
                scope.row.checkUsers.indexOf(userId) > -1
              " @click.native.prevent="del(scope.row)" type="text" size="small">
                删除
              </el-button>
            </div>

            <el-button style="color: #387ee8" v-if="scope.row.count > 0" @click.native.prevent="showData(scope.row)"
              type="text" size="small">
              查看附件
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="common.page"
          :page-size="common.pageSize" :page-sizes="common.allSizes" layout="total,sizes, prev, pager, next, jumper"
          :total="common.total">
        </el-pagination>
      </div>
    </div>
    <!--审核 -->
    <div v-if="checkVisible">
      <check ref="check"></check>
    </div>
    <!-- 查看附件弹出框 -->
    <div v-if="evaluateFileVisible">
      <evaluateFile ref="evaluateFile"></evaluateFile>
    </div>
  </div>
</template>

<script>
import http from "../../../../common/http";
import check from "./StudentCheck.vue";
import evaluateFile from "./EvaluateFile.vue";

export default {
  name: "StudentEvaluate",
  data() {
    return {
      loading: false,
      loadingText: "",
      checkVisible: false,
      evaluateFileVisible: false,
      common: {
        total: 0, //总数据量
        pageSize: 30, //每页条数
        page: 1, //页码
        isPage: 1, //是否分页
        allSizes: [30, 50, 100], //每页条数筛选
        checkboxArr: [], //多选框数组
      },
      form: {
        id: "",
        serialNo: "",
        moduleId: "",
        name: "",
        className: "",
        gradeName: "",
        deptId: "",
        checkStatus: "",
        evaluateTitle: "",
        createName: "",
      },
      userId: "",
      checkStatuss: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 0,
          label: "不通过",
        },
        {
          value: 1,
          label: "待审核",
        },
        {
          value: 2,
          label: "审核通过",
        },
      ],
      evaluateModules: [],
      depts: [],
      data: [],
    };
  },
  components: {
    check,
    evaluateFile,
  },
  created: function () {
    this.getDeptData();
    let userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
    if (userinfo != null && userinfo != "") {
      this.userId = userinfo.id;
    }
  },
  methods: {
    indexMethod(index) {
      return (this.common.page - 1) * this.common.pageSize + (index + 1);
    },
    selectable(row) {
      return true;
    },
    getDeptData() {
      //部门管理
      let url = this.listDeptUrl;
      let data = { parentId: "0" };
      this.apiPost(url, data).then(
        (res) => {
          if (res.status == 200) {
            this.depts = res.data.list;
            if (this.depts.length > 0) {
              this.form.deptId = this.depts[0].id
            }
            this.getData()
            this.getModuleBindIndicators()
          } else {
            this.$commonFn.showTip(res.message, 3);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getData() {
      let url = this.studentEvaluateIndicatorsCheckListUrl
      let data = {
        isPage: this.common.isPage,
        page: this.common.page,
        limit: this.common.pageSize,
        serialNo: this.form.serialNo,
        moduleId: this.form.moduleId == "0" ? "" : this.form.moduleId,
        deptId: this.form.deptId,
        name: this.form.name,
        className: this.form.className,
        gradeName: this.form.gradeName,
        checkStatus: this.form.checkStatus,
        evaluateTitle: this.form.evaluateTitle,
        createName: this.form.createName,
      };

      this.loading = true
      this.loadingText = "数据在加载中..."
      // console.log(JSON.stringify(data))
      this.apiPost(url, data).then(
        (res) => {
          if (res.status == 200) {
            this.data = res.data.list;
            this.common.total = res.data.total;
          } else {
            this.$commonFn.showTip(res.message, 3);
          }
          this.loading = false;
        },
        (err) => {
          this.loading = false;
        }
      );
    },
    getModuleBindIndicators() {
      let url = this.moduleBindIndicatorsListModuleUrl;
      let data = {
        deptId: this.form.deptId,
      };

      this.apiPost(url, data).then(
        (res) => {
          console.log('学生/课堂/成果', JSON.stringify(res.data))
          if (res.status == 200) {
            // 遍历模块
            let m = res.data;
            let em = [];
            for (let i = 0; i < m.length; i++) {
               if (m[i].moduleTitle.indexOf("班级") > -1 
                        || m[i].moduleTitle.indexOf("教职") >-1 ){
                continue
               }
               em.push(m[i])
            }
            this.evaluateModules = em;
            this.form.moduleId = "";
          } else {
            this.$commonFn.showTip(res.message, 3);
          }
        },
        (err) => { }
      );
    },
    handleSizeChange(val) {
      this.common.pageSize = val;
      this.common.page = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      this.common.page = val;
      this.getData();
    },
    handleSelectionChange(val) {
      this.common.checkboxArr = [];
      for (let i = 0; i < val.length; i++) {
        this.common.checkboxArr.push(val[i]);
      }
    },
    // 批量审批
    batchCheck() {
      let sCount = this.common.checkboxArr.length
      if (sCount > 0) {
        let checkIdArr = new Array()
        for (let i = 0; i < sCount; i++) {
          let selectData = this.common.checkboxArr[i]
          // 审核状态（0-审核不通过，1-待审核，2-审核通过）
          if (selectData.checkStatus == 1) {
            checkIdArr.push(selectData.id)
          }
        }

        if (checkIdArr.length == 0) {
          this.$commonFn.showTip("选中" + sCount + "条数据，无符合审批数据。请选择待审核数据，再重新审批。", 2)
          return
        }

        let ids = checkIdArr.join(",");
        this.checkVisible = true;
        this.$nextTick(() => {
          console.log('sCount', sCount, "ids", ids)
          this.$refs["check"].init(sCount, ids, false);
        });
      } else {
        this.$commonFn.showTip("请选择审批数据", 2);
      }
    },
    // 单个审批
    checkUser(ids) {
      this.checkVisible = true;
      this.$nextTick(() => {
        console.log("ids", ids)
        this.$refs["check"].init(1, ids, true);
      });
    },
    // 批量撤销
    batchCancel() {
      let sCount = this.common.checkboxArr.length
      if (sCount > 0) {
        let checkIdArr = new Array();
        for (var i = 0; i < sCount; i++) {
          let selectData = this.common.checkboxArr[i]
          // 审核状态（0-审核不通过，1-待审核，2-审核通过）
          if (selectData.checkStatus == 2) {
            checkIdArr.push(selectData.id)
          }
        }

        if (checkIdArr.length == 0) {
          this.$commonFn.showTip("选中" + sCount + "条数据，无符合撤销数据。请选择审核通过的数据，再重新批量撤销。", 2)
          return
        }

        let ids = checkIdArr.join(",")
        this.form.id = ids
        let tipMsg = "选中" + sCount + "条数据，符合撤销条件" + checkIdArr.length + "条数据。此操作将撤销已评价的数据，会影响到班级考核, 是否继续?"
        this.$commonFn.showConfirm2(tipMsg, this.cancelSuccess)
      }
      else {
        this.$commonFn.showTip("请选择删除数据", 2)
      }
    },
    // 单个撤销
    cancelUser(id) {
      this.form.id = id
      this.$commonFn.showConfirm2("此操作将撤销已评价的数据，会影响到该学生排名, 是否继续?", this.cancelSuccess)
    },
    cancelSuccess() {
      let url = this.studentEvaluateIndicatorsCancelUrl
      let data = { id: this.form.id, };

      this.loading = true
      this.loadingText = "数据撤销中..."
      this.apiPost(url, data).then((res) => {
        if (res.status === 200) {
          this.$commonFn.showTip(res.message, 4, true)
          this.getData()
        } else {
          this.$commonFn.showTip(res.message, 3)
          this.visible = false
        }
      },
        (err) => {
          console.log(err)
          this.loading = false
        }
      );
    },
    showData(row) {
      this.evaluateFileVisible = true;
      this.$nextTick(() => {
        this.$refs["evaluateFile"].init(this.form.deptId, row.id);
      });
    },
    //批量删除
    batchDelete() {
      let sCount = this.common.checkboxArr.length
      if (sCount > 0) {
        let checkIdArr = new Array();
        for (let i = 0; i < sCount; i++) {
          let selectData = this.common.checkboxArr[i]
          // 审核状态（0-审核不通过，1-待审核，2-审核通过）
          if (selectData.checkStatus == 1) {
            checkIdArr.push(selectData.id)
          }
        }
        if (checkIdArr.length == 0) {
          this.$commonFn.showTip("选中" + sCount + "条数据，无符合删除数据。请选择待审批数据，再重新批量删除。", 2)
          return
        }

        let ids = checkIdArr.join(",");
        this.form.id = ids;
        let tipMsg = "选中" + sCount + "条数据，符合删除条件" + checkIdArr.length + "条数据。此操作将永久删除该数据, 是否继续?"
        this.$commonFn.showConfirm2(tipMsg, this.delSuccess)
      } else {
        this.$commonFn.showTip("请选择删除数据", 2)
      }
    },
    // 单个删除
    del(data) {
      this.form.id = data.id
      this.$commonFn.showConfirm(this.delSuccess)
    },
    delSuccess() {
      let url = this.studentEvaluateIndicatorsCheckRemoveUrl
      let data = {
        id: this.form.id,
      };

      this.loading = true
      this.loadingText = "数据删除中..."
      this.apiPost(url, data).then((res) => {
        if (res.status == 200) {
          this.$commonFn.showTip(res.message, 1)
          this.common.page = 1
          this.getData()
        } else {
          this.loading = true
          this.$commonFn.showTip(res.message, 3)
        }
      },
        (err) => {
          this.loading = false
          console.log(err)
        }
      );
    },
  },
  mixins: [http],
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/StudentEvaluateCheck.vue